import styles from './LinearProgress.module.scss';

function LinearProgress() {
  return (
    <div className={styles.loaderContainer}>
      <div className={styles.loaderBar1} />
      <div className={styles.loaderBar2} />
    </div>
  );
}

export default LinearProgress;
